// Monochrome
export const white = '#ffffff';
export const alabaster = '#f9f9f9';
export const alabasterDark = '#f7f7f7';
export const whiteSmoke = '#f6f6f6';
export const whitesmoke2 = '#ECECEC';
export const concreteLight = '#f5f5f5';
export const concrete = '#f2f2f2';
export const blackFaze = '#f0f2f1';
export const gallery = '#eeeeee';
export const mercury = '#e3e3e3';
export const gainsboro = '#e5e5e5';
export const alto = '#dadada';
export const altoLight = '#dcdcdc';
export const silver = '#cccccc';
export const mediumGray = '#bfbfbf';
export const silverChalice = '#aaaaaa';
export const silverV2 = '#b9b9b9';
export const dustyGray = '#999999';
export const lightslategray = '#929292';
export const lightsLighterGray = '#8D8C8C';
export const grayLighter = '#888';
export const gray = '#808080';
export const friarGray = '#7b7b7a';
export const doveGray = '#737373';
export const doveGrayWithOpacity = '#73737380';
export const paleSky = '#6c757d';
export const scorpion = '#585858';
export const emperor = '#505050';
export const mineShaft = '#333333';
export const zeus = '#30251c';
export const mineShaftDark = '#212121';
export const codGray = '#1a1a1a';
export const darkslategray = '#4a4a4a';
export const black = '#000000';
export const Tags04Neutral = whitesmoke2;
export const graySmoke = '#eaebed'; // paycor profile background
export const darkSmoke = '#cbcdd1'; // paycor fast rating dashed border color

// White
export const quarterSpanishWhite = '#faf4eb';
export const quarterPearlLusta = '#fffbf2';
export const halfSpanishWhite = '#fef2dc';
export const bridalHeath = '#fff9ee';
export const mystic = '#e1e9ee';
export const selago = '#f8f7fe';
export const wildSand = '#f5f5f5';
export const pearlLusta = '#fcf8e3';
export const champagne = '#faf2cc';
export const bizarre = '#f2dede';
export const oysterPink = '#ebcccc';
export const cinderella = '#fce6e2';
export const peppermint = '#dff0d8';
export const zanah = '#d0e9c6';
export const linkWater = '#d9edf7';
export const mintTulip = '#c4e3f3';
export const orangeWhite = '#fef9ee';
export const chineseWhite = '#d8f0e3';

// Blue
export const blueberryBlue = '#1347cf';
export const cornflowerblue = '#6b9efb';
export const pictonBlue = '#419ee0';
export const astral = '#337ab7';
export const mariner = '#1f7bbd';
export const matisse = '#145f96';
export const oxfordBlue = '#3c4858';
export const steelblue = '#2B57AD';
export const darkBlue = '#1F1853';
export const royalBlueDark = '#193D6A'; // paycor fast rating links color
export const lightSkyBlue = '#b6e2f4'; // paycor fast rating dashed element hover color, preferred skill color
export const darkSkyBlue = '#30addf'; // paycor must have skill color
export const skyBlue = '#86cfec'; // paycor important skill color, marked/highlighted text color
export const paleSkyBlue = '#e3f4fb'; // paycor optional skill color
export const whiteSky = '#e2f3fa'; // paycor selected skill color
export const batteryChargedBlue = '#24a1d5';
export const bondi = '#14698c'; // paycor manual qualify primary color
export const cyanCornflowerBlue = '#1c85b0'; // paycor manual qualify button color
export const darkCyanBlue = '#1b467a';

// Turquoise
export const paleturquoise = '#97ebeb';
export const brightTurquoise = '#00d3ee';
export const scooter = '#26c6da';
export const pacificBlue = '#00acc1';
export const denim = '#118CC0';

// Green
export const sushi = '#80b636';
export const fern = '#66bb6a';
export const oceanGreen = '#3bb273';
export const apple = '#43a047';
export const fruitSalad = '#4caf50';
export const forestGreen = '#188038';
export const slimeGreen = '#acd2a2'; // paycor insight green
export const firTreeGreen = '#4f903c'; // paycor qualify green button red
export const greenApple = '#4d8e3c';
export const mayGreen = '#59a545';
// Yellow
export const sandyBeach = '#fec';
export const texas = '#faeb9a';
export const mustard = '#ffdb5b';
export const buttermilk = '#fff6b3';
export const goldenDream = '#f6e335';
export const cherokee = '#fbdd9f';
export const casablanca = '#f8c051';
export const saffronMango = '#f8c052';
export const gold = '#F6D835';
export const gamboge = '#e49d0a';

export const darkYellow = '#ffdd00'; // Must have
export const middleYellow = '#fff5b3'; // Important
export const lightYellow = '#fffbe0'; // Preferred
export const paleYellow = '#fffbe0'; // Optional

// Orange
export const buttercup = '#f7b31b';
export const sunshade = '#ffa726';
export const orangePeel = '#ff9800';
export const pizazz = '#fb8c00';
export const tuscany = '#ce5c32';
export const tangerine = '#f06439';

// Red
export const burntSienna = '#ef5350';
export const pomegranate = '#f44336';
export const cinnabar = '#e53935';
export const cinnabarLight = '#e65239';
export const red = '#ff0000';
export const radicalRed = '#ff234c';
export const alizarinCrimson = '#e52d27';
export const rubyLight = '#f68d90'; // paycor insight red color
export const vividRed = '#ec1b21'; // paycor disqualify red button color
export const lightGrayishRed = '#fadcd7';

// Pink
export const seaPink = '#ec8f8b';
export const frenchRose = '#ea4c89';
export const amaranth = '#e91e63';
export const pink = '#C30BE1';

// Purple
export const amethyst = '#ab47bc';
export const purpleHeart = '#af2cc5';
export const perfume = '#dbb4f7';
export const seance = '#a517aa';
export const lavender = '#b17ce5';
export const royalblue = '#4632E2';
export const lightsteelblue = '#C0B8FF';
export const slateblue = '#7366DB';
export const mediumslateblue = '#7564fb';
export const darkslatesgray2 = '#46354a';
export const Minsk = '#42377a';

// Social Network colors
export const twitterBrandColor = '#55acee';
export const facebookBrandColor = '#3b5998';
export const googleBrandColor = '#dd4b39';
export const linkedinBrandColor = '#0976b4';
export const pinterestBrandColor = '#cc2127';
export const youtubeBrandColor = '#e52d27';
export const tumblrBrandColor = '#35465c';
export const githubBrandColor = '#333333';
export const behanceBrandColor = '#1769ff';
export const dribbbleBrandColor = '#ea4c89';
export const redditBrandColor = '#ff4500';
export const instagramBrandColor = '#125688';

export const criteriaTileOptionalColor = '#fbdd9f';
export const criteriaTileOptionalFontWeight = 'normal';
export const criteriaTilePreferredColor = '#f8c051';
export const criteriaTilePreferredFontWeight = 'normal';
export const criteriaTileMandatoryColor = '#e49d0a';
export const criteriaTileMandatoryFontWeight = 'normal';
export const criteriaTileFilterColor = '#ce5c32';
export const criteriaTileFilterFontWeight = 'normal';

export const tpaPoorHealthBackground = cinderella;
export const tpaFairHealthBackground = quarterPearlLusta;
export const tpaOptimalHealthBackground = '#e1f3ea';

export const manualSelectInfo = '#1C85B01a';
